import React from 'react';
import { FaFacebook, FaTwitterSquare, FaGithubSquare, FaLinkedin } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className='max-w-[1920px] mx-auto lg:px-20 px-5 border-t border-black'>
            <div className='lg:flex lg:justify-between my-5 justify-center'>
                <p className='text-center mb-5 lg:mb-0'>©2022 Resalat. All rigths reserved</p>
                <div className='flex gap-5 text-xl justify-center'>
                    <a href="https://web.facebook.com/resalat.islam.18/" target="blank"><FaFacebook /> </a>
                    <a href="https://twitter.com/resalatislam5" target="blank"><FaTwitterSquare /> </a>
                    <a href="https://github.com/resalatislam5" target="blank"><FaGithubSquare /> </a>
                    <a href='https://www.linkedin.com/in/resalat-islam/' target="blank"><FaLinkedin /> </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;